function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrideplaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 182.4 63.7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.0423259735107422, 0, 0, 1.0720750093460083, -186.30847167968747, -249.03274536132812)",
    style: {}
  }), /*#__PURE__*/React.createElement("g", {
    style: {},
    transform: "matrix(1.1856820583343506, 0, 0, 1.1856820583343506, -216.06694030761716, -275.0795593261719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 222.456 272.246 L 231.64 272.246 L 231.64 264.632 L 233.603 264.632 L 238.783 272.246 L 249.263 272.246 L 242.865 263.186 C 246.202 261.626 248.282 258.923 248.282 255.04 L 248.282 254.964 C 248.282 252.224 247.418 250.244 245.77 248.645 C 243.846 246.78 240.746 245.6 235.879 245.6 L 222.456 245.6 L 222.456 247.908 C 224.668 249.487 225.948 251.877 225.948 255.078 L 225.948 255.154 C 225.948 258.387 224.669 260.861 222.456 262.521 L 222.456 272.246 L 222.456 272.246 Z M 231.64 258.276 L 231.64 253.061 L 235.644 253.061 C 237.763 253.061 239.137 253.898 239.137 255.611 L 239.137 255.687 C 239.137 257.324 237.803 258.276 235.605 258.276 L 231.64 258.276 L 231.64 258.276 Z",
    style: {
      fill: "rgb(141, 141, 141)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 251.323 272.246 L 260.602 272.246 L 260.602 248.175 L 260.602 245.6 L 251.323 245.6 L 251.323 248.163 L 251.323 272.246 Z",
    style: {
      fill: "rgb(141, 141, 141)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 291.534 272.245 L 315.248 272.245 L 315.248 264.937 L 300.594 264.937 L 300.594 262.044 L 314.066 262.044 L 314.066 255.611 L 300.594 255.611 L 300.594 252.908 L 315.051 252.908 L 315.051 245.6 L 291.534 245.6 L 291.534 250.866 C 293.188 252.973 294.015 255.632 294.015 258.694 L 294.015 258.771 C 294.015 261.801 293.187 264.493 291.534 266.661 L 291.534 272.246 L 291.534 272.245 Z",
    style: {
      fill: "rgb(141, 141, 141)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 198.741 272.245 L 207.961 272.245 L 207.961 265.013 L 210.956 265.013 C 218.403 265.013 223.486 261.587 223.486 255.154 L 223.486 255.078 C 223.486 248.76 218.481 245.6 211.153 245.6 L 198.741 245.6 L 198.741 272.246 L 198.741 272.245 Z M 207.961 258.656 L 207.961 252.718 L 210.483 252.718 C 212.925 252.718 214.384 253.707 214.384 255.648 L 214.384 255.725 C 214.384 257.628 212.808 258.656 210.444 258.656 L 207.961 258.656 Z",
    style: {
      fill: "rgb(141, 141, 141)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 264.729 272.246 L 274.904 272.246 C 285.979 272.246 291.537 266.65 291.537 258.771 L 291.537 258.694 C 291.537 250.815 286.097 245.6 275.217 245.6 L 264.729 245.6 L 264.729 272.246 L 264.729 272.246 Z M 275.413 253.366 C 279.601 253.366 282.301 255.04 282.301 258.885 L 282.301 258.961 C 282.301 262.805 279.601 264.48 275.413 264.48 L 273.887 264.48 L 273.887 253.366 L 275.413 253.366 Z",
    style: {
      fill: "rgb(141, 141, 141)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrideplaceholder);
export default __webpack_public_path__ + "static/media/prideplaceholder.30d58f00974dfc5097770fb50bc05c30.svg";
export { ForwardRef as ReactComponent };